import { GLOBAL_VARS, StorageKeys } from '@centerhealth/common/storage';
import localForage from 'localforage';
import _ from '@centerhealth/common/lodash';

class Storage {
  private commonStorage: LocalForage;

  private userStorage: LocalForage;

  constructor() {
    // Not to be used SSR. client only
    this.commonStorage = localForage.createInstance({
      name: 'Center Health',
      storeName: 'common',
      driver: localForage.LOCALSTORAGE,
    });
  }

  get = async <T>(key: StorageKeys | string, defaultValue: T | null = null): Promise<T | null> => {
    const storage = await this.getStorage(key);
    const value = await storage.getItem<T>(key);
    return value || defaultValue;
  };

  set = async <T>(key: StorageKeys | string, value: T): Promise<T> => {
    const storage = await this.getStorage(key);
    return storage.setItem<T>(key, value);
  };

  remove = async (key: StorageKeys | string): Promise<void> => {
    const storage = await this.getStorage(key);
    await storage.removeItem(key);
  };

  private getStorage = async (key: string): Promise<LocalForage> => {
    // Return common storage form global variables
    if (_.includes(GLOBAL_VARS, key)) return this.commonStorage;

    // Return user storage if defined otherwise create it
    if (this.userStorage) return this.userStorage;

    let userId;
    try {
      // TODO: check for teamlink
      const token = await this.get<string>(StorageKeys.jwtToken);
      // https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
      if (token) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        userId = JSON.parse(atob(token.split('.')[1])).sub;
      }
      this.userStorage = localForage.createInstance({
        name: 'User Storage',
        storeName: userId,
      });

      return this.userStorage;
    } catch (e) {
      // Fallback to common Storage ?
      return this.commonStorage;
    }
  };
}

export const StorageService: Storage = new Storage();
